import React, { memo } from 'react'
import { Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import {
  getCollectDataStepConfigs,
  getCollectDataStepIndexInConfig,
  getCurrentCollectDataStepConfig,
  getCurrentCollectDataStepConfigIndex,
} from 'src/selectors/collectData'
import tw from 'twin.macro'

interface Props {
  stepId: string | undefined
}

const CollectDataStepIndexComponent = ({ stepId }: Props) => {
  const collectDataStepIndex = useSelector(getCollectDataStepIndexInConfig(stepId))
  const collectDataStepConfigs = useSelector(getCollectDataStepConfigs)
  const currentCollectDataStepConfig = useSelector(getCurrentCollectDataStepConfig)
  const currentCollectDataStepConfigIndex = useSelector(getCurrentCollectDataStepConfigIndex)

  return (
    <div css={tw`rounded bg-primary-100 px-1 mb-2 w-fit`}>
      <Typography variant="overline" css={tw`text-primary-500`}>
        {`STEP ${currentCollectDataStepConfigIndex} OF ${collectDataStepConfigs.length}${
          currentCollectDataStepConfig?.collectDataSteps &&
          currentCollectDataStepConfig?.collectDataSteps.length > 1
            ? ` • PART ${collectDataStepIndex} OF ${currentCollectDataStepConfig?.collectDataSteps.length}`
            : ''
        }`}
      </Typography>
    </div>
  )
}

export const CollectDataStepIndex = memo(CollectDataStepIndexComponent)
